import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

gsap.registerPlugin(ScrollTrigger);

export default function(){
	let isMobile = false
	if ( window.innerWidth < 827 ) {
		isMobile = true
	}


	/* SLIDERS */

	const mediaSliders = document.querySelectorAll( '.media-slider' )

	if ( mediaSliders.length > 0 ) {
		mediaSliders.forEach(slider => {
			let mediaSlider = new Swiper( slider, {
				// configure Swiper to use modules
				modules: [Navigation, Autoplay],
				loop: true,
				draggable: true,
				allowTouchMove: true,
				effect: 'slide',
				spaceBetween: 20,
				slidesPerView: 1,
				slidesPerGroup: 1,

				autoplay: {
					delay: 5000,
				},

				navigation: {
					prevEl: '.slider-button-prev',
					nextEl: '.slider-button-next',
				},
			});

			// Function to add zero before numbers below 10
			let helpers = {
				addZeros: function (n) {
					return (n < 10) ? '0' + n : '' + n;
				}
			};
	
			if ( mediaSlider ){
				mediaSlider.on('slideChange', function () {
					const currentSlide = this.slides[this.realIndex];
					const currentCounter = currentSlide.parentNode.parentNode.querySelector('.counter .current');

					currentCounter.innerHTML = helpers.addZeros(this.realIndex + 1);
				});
			}
		});

	}

	const statsSliders = document.querySelectorAll( '.stats-slider' )

	if ( statsSliders.length > 0 ) {
		statsSliders.forEach(slider => {
			let statsSlider = new Swiper( slider, {
				// configure Swiper to use modules
				modules: [Pagination, Autoplay],
				loop: true,
				draggable: true,
				allowTouchMove: true,
				effect: 'slide',
				spaceBetween: 20,
				slidesPerView: 1,
				slidesPerGroup: 1,

				autoplay: {
					delay: 5000,
				},

				pagination: {
					el: '.slider-pagination',
					type: 'bullets',
					clickable: true,
				},
			});
		});
	}


	/* Strip funcionality */
	
	// Variables
	const stickyTabsGroup  = document.querySelector( '.sticky-tabs' )
	const stickyTabsHeader = document.querySelector( '.sticky-tabs__header' )
	const mediaColumn      = document.querySelector( '.grid-column-media' )
	const textColumn       = document.querySelector( '.grid-column-text' )
	const textBlocks       = document.querySelectorAll( '[data-text]' )
	let endTriggerPoint = [].slice.call(textBlocks).pop() // last content block

	// Preparation: only first media block visible
	const imagesBlocks = document.querySelectorAll( '[data-media]' )

	if ( ! isMobile && imagesBlocks.length > 0 ) {
		imagesBlocks.forEach( ( image, index ) => {
			if ( index !== 0 ) {
				image.style.opacity = 0
			}
		});
	}

	// Preparation: Set heights
	if ( ! isMobile && stickyTabsGroup ){
		let spaceForMediaSlider = window.innerHeight - ( stickyTabsHeader.clientHeight + ( calculateVerticalSpace(stickyTabsHeader, mediaColumn, 'bottom', 'top' ) * 2 ) )
	
		//gsap.set( textBlocks, { minHeight: '100vh' } )
		gsap.set( textBlocks[textBlocks.length - 1], { minHeight: '100vh' } )
		gsap.set( '.grid-column-media .swiper-slide', { maxHeight: spaceForMediaSlider + 'px'} )
	}




	// Pin tab header and media column
	if ( ! isMobile ) {
		if ( stickyTabsHeader ) {
			ScrollTrigger.create({
				trigger: stickyTabsHeader,
				endTrigger: endTriggerPoint,
				pin: stickyTabsHeader,
				pinSpacing: false,
				anticipatePin: 1,
				start: "top top",
				end: `top top`,
				//markers: true,
			});
		}
		if ( mediaColumn ) {
			ScrollTrigger.create({
				trigger: mediaColumn,
				endTrigger: endTriggerPoint,
				pin: mediaColumn,
				pinSpacing: false,
				anticipatePin: 1,
				start: `top top+=${stickyTabsHeader.clientHeight + calculateVerticalSpace(stickyTabsHeader, mediaColumn, 'bottom', 'top' )}px`,
				end: `bottom bottom-=${stickyTabsHeader.clientHeight + calculateVerticalSpace(stickyTabsHeader, mediaColumn, 'bottom', 'top' )}px`,
				//markers: true,
			});
		}
	
		// Spy Scroll like animation
		// - changing the media sliders depending on the text showing
		// - updates progress bar (header tabs)
		if ( textBlocks.length > 0 ) {
			textBlocks.forEach(content => {
				let contentNumber    = content.dataset.text
				let relatedMedia     = document.querySelector( '[data-media="' + contentNumber + '"]' )
				let relatedContent   = document.querySelector( '[data-text="' + contentNumber + '"]' )
				let relatedTitle     = relatedContent.querySelector( '[data-target]' ).dataset.target
	
				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: content,
						start: 'top top+=50%',
						toggleActions:"play complete play reset",
						//markers: true
						onEnter: ({progress, direction, isActive}) => updateProgressBar(relatedTitle),
						onEnterBack: ({progress, direction, isActive}) => { updateProgressBar(relatedTitle) },
					}
				});
	
				tl.to( relatedMedia, { opacity: 1 } )
			});
	
			function updateProgressBar( slug ){
				let progressBar = stickyTabsHeader?.querySelector( '.progress-bar' )
				let headerItem = document.querySelector( '[data-to-target='+ slug +']' )
	
				if ( headerItem ){
					let spaceFromTheLeft = headerItem.getClientRects()[0].x
	
					gsap.to( progressBar, { width: spaceFromTheLeft + 'px', ease: 'power1.out', duration: 0.8 } )
				}
			}
		}
	}




	/* Scroll to */
	const navPoints = document.querySelectorAll( '[data-to-target]' )

	if ( navPoints.length > 0 ){
		navPoints.forEach(point => {
			point.addEventListener('click', function () {
				let target = document.querySelector('[data-target=' + point.dataset.toTarget + ']');
				let spacing = 150; // Adjust the value to add spacing (in pixels) before the element
				let targetOffset = target.getBoundingClientRect().top;

				window.scrollBy({
					top: targetOffset - spacing,
					behavior: 'smooth',
				});
			});
		});
	}





	/* Helper functions */
	function calculateVerticalSpace(element1, element2, position1, position2) {
		const rect1 = element1.getBoundingClientRect();
		const rect2 = element2.getBoundingClientRect();
		
		const verticalSpace = rect2[position2] - rect1[position1];
	
		return verticalSpace;
	}
}

